import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const iconMap = {
  user: 'icon-user',
  users: 'icon-users',
  property: 'icon-home',
  note: 'icon-comment',
  comment: 'icon-comment',
  stickyNote: 'icon-sticky-note',
  project: 'icon-wrench',
  maintenance: 'icon-wrench',
  inspection: 'icon-search',
  housekeeping: 'icon-magic',
  cleaning: 'icon-magic',
  cost: 'icon-usd',
  details: 'icon-info-circle',
  photo: 'icon-picture',
  camera: 'icon-camera',
  summary: 'icon-list-alt',
  feedback: 'icon-list-alt',
  bolt: 'icon-bolt',
  'folder-open': 'icon-folder-open',
  checklist: 'icon-checklist',
  yes_no: 'icon-question',
  edit: 'icon-edit',
  up: 'icon-chevron-up',
  down: 'icon-chevron-down',
  right: 'icon-chevron-right',
  left: 'icon-chevron-left',
  'caret-up': 'icon-caret-up',
  'caret-down': 'icon-caret-down',
  'caret-right': 'icon-caret-right',
  'caret-left': 'icon-caret-left',
  start: 'icon-play',
  pause: 'icon-pause',
  stop: 'icon-stop',
  check: 'icon-check',
  pencil: 'icon-pencil',
  plus: 'icon-plus',
  circle: 'icon-circle',
  'circle-close': 'icon-circle-close',
  'circle-thin': 'icon-circle-thin',
  calendar: 'icon-calendar-plus',
  schedule: 'icon-calendar',
  settings: 'icon-cog',
  envelope: 'icon-envelope',
  mobile: 'icon-mobile',
  star: 'icon-star',
  'star-o': 'icon-star_empty',
  text: 'icon-font',
  access: 'icon-lock',
  delete: 'icon-trash-c',
  fail: 'icon-times',
  refresh: 'icon-refresh',
  'thumbs-up': 'icon-thumbs-up',
  'thumbs-down': 'icon-thumbs-down',
  table: 'icon-th-large',
  signout: 'icon-signout',
};

const ObjectIcon = props => (
  <i
    className={classnames(iconMap[props.object], props.className, {
      'fa-fw': props.fixedWidth,
      [`fa-stack-${props.size}`]: props.stack,
      [`fa-${props.size}`]: !props.stack && props.size,
      'fa-inverse': props.inverse,
    })}
    aria-hidden="true"
  />
);

ObjectIcon.propTypes = {
  object: PropTypes.string,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  size: PropTypes.oneOf(['lg', '1x', '2x', '3x', '4x', '5x']),
  fixedWidth: PropTypes.bool,
  inverse: PropTypes.bool,
  stack: PropTypes.bool,
};

ObjectIcon.defaultProps = {
  fixedWidth: false,
  inverse: PropTypes.false,
  stack: PropTypes.false,
};

export default ObjectIcon;
